import { lazyLoad } from '@/lib/LazyLoad';

export const FilterDetailPage = lazyLoad(
  () => import('./FilterDetailPage'),
  (module) => module.FilterDetailPage
);
